module.exports = __webpack_public_path__ + "img/thermometer.min.42d4e12639230a2372add967ed880b87.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/thermometer.min.svg
// module id = 178
// module chunks = 0